import {
    useState, useMemo,
} from 'react'
import isEqual from 'lodash/isEqual'

import IntegerRangeSelector from 'app/shared-components/IntegerRangeSelector'
import {
    IntegerRangeFilterOptions,
} from 'app/types/common.types'
import FilterPopover from '../FilterPopover'

type FilterType<T = number | null> = {
    from: T,
    to: T,
}

const defaultProps = {
    filter: {
        from: null,
        to: null,
    },
}

export default function IntegerRangeFilter({
    filter, setFilter, filterOptions,
}: Readonly<{
    filter?: FilterType<number | string | null>,
    setFilter: (filter: FilterType<number | string | null>) => void,
    filterOptions?: IntegerRangeFilterOptions
}>) {
    const [
        state,
        setState,
    ] = useState<FilterType>(() => {
        return ({
            from: filterOptions?.parse?.from
                ? filterOptions?.parse?.from?.(filter)
                : filter.from,
            to: filterOptions?.parse?.to
                ? filterOptions?.parse?.to?.(filter)
                : filter.to,
        })
    })

    const [
        hasChanges,
        setHasChanges,
    ] = useState<boolean>(false)

    const commitChanges = (): void => {
        if (hasChanges) {
            setFilter({
                from: filterOptions?.convert?.from
                    ? filterOptions?.convert?.from?.(state) : state.from,
                to: filterOptions?.convert?.to ? filterOptions?.convert?.to?.(state) : state.to,
            })
        }
    }

    const localOnChange = (newValue: FilterType): void => {
        setState({
            ...newValue,
        })

        if (!isEqual(newValue, state)) {
            setHasChanges(true)
        }
    }

    const active = useMemo((): boolean => {
        return Boolean(filter.from || filter.to)
    }, [filter])

    return (
        <FilterPopover
            active={active}
            onClose={commitChanges}

        >
            <IntegerRangeSelector
                from={state?.from}
                to={state?.to}
                onChange={localOnChange}
                titleFrom={filterOptions?.labels?.from}
                titleTo={filterOptions?.labels?.to}
            />
        </FilterPopover>
    )
}

IntegerRangeFilter.defaultProps = defaultProps
